/**
 * Diagnox search modal — empty + search states.
 * Product CTA: always "VIEW TEST".
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 220;
  var RESULT_LIMIT = 10;

  // Result groups shown on each tab.
  var TAB_GROUPS = {
    product: ['products'],
    biomarker: ['biomarkers'],
    condition: ['conditions'],
    article: ['articles'],
    faq: ['faqs']
  };

  // Tabs served by Shopify predictive search; the rest come from the content index.
  var PREDICTIVE_TYPES = {
    all: 'product,article',
    product: 'product',
    biomarker: 'product',
    article: 'article'
  };

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHtml(value) {
    var str = String(value == null ? '' : value);
    if (!str) return '';

    // Strip tags first, then decode entities via DOM
    str = str
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, ' ')
      .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, ' ')
      .replace(/<\s*br\s*\/?>/gi, ' ')
      .replace(/<\s*li[^>]*>/gi, ' ')
      .replace(/<[^>]+>/g, ' ');

    if (typeof document !== 'undefined') {
      var div = document.createElement('div');
      div.innerHTML = str;
      str = div.textContent || div.innerText || str;
    }

    return String(str)
      .replace(/&nbsp;/gi, ' ')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseProductMeta(root) {
    var node = root.querySelector('[data-diagnox-product-meta]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}') || {};
    } catch (err) {
      return {};
    }
  }

  function parseContentIndex(root) {
    var node = root.querySelector('[data-diagnox-content-index]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}') || {};
    } catch (err) {
      return {};
    }
  }

  // Case-insensitive match on title and description; title matches first.
  // Biomarker handles from the Biomarkers metafield of products whose name
  // contains the query as a word (e.g. "UTI" -> UTI Test Strips ->
  // Leukocytes and Nitrite in Urine).
  function linkedBiomarkers(productMeta, query) {
    var q = String(query || '').trim().toLowerCase();
    var linked = {};
    if (!q) return linked;
    var escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var pattern = new RegExp('(^|[^a-z0-9])' + escaped + '($|[^a-z0-9])');
    Object.keys(productMeta || {}).forEach(function (key) {
      var meta = productMeta[key] || {};
      if (!pattern.test(String(meta.title || '').toLowerCase())) return;
      [].concat(meta.biomarkers || []).forEach(function (handle) {
        if (handle) linked[handle] = true;
      });
    });
    return linked;
  }

  function searchIndex(entries, query, type, linked) {
    var q = String(query || '').trim().toLowerCase();
    if (!q || !entries || !entries.length) return [];
    var titleHits = [];
    var linkedHits = [];
    var textHits = [];
    linked = linked || {};
    entries.forEach(function (entry) {
      var item = {
        type: type,
        title: entry.title || '',
        url: entry.url || '#',
        description: entry.description || '',
        image: entry.image || ''
      };
      if (String(item.title).toLowerCase().indexOf(q) !== -1) titleHits.push(item);
      else if (entry.handle && linked[entry.handle]) linkedHits.push(item);
      else if (String(item.description).toLowerCase().indexOf(q) !== -1) textHits.push(item);
    });
    return titleHits.concat(linkedHits, textHits);
  }

  function handleFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function lookupProductMeta(metaMap, product) {
    var handle = product.handle || handleFromUrl(product.url);
    if (handle && metaMap[handle]) return metaMap[handle];

    var keys = Object.keys(metaMap);
    for (var i = 0; i < keys.length; i += 1) {
      var entry = metaMap[keys[i]];
      if (entry && product.url && entry.url === product.url) return entry;
      if (entry && product.id && String(entry.id) === String(product.id)) return entry;
    }
    return null;
  }

  function viewLabelFromSample() {
    return 'VIEW TEST';
  }

  function highlight(text, query) {
    var raw = stripHtml(text);
    var q = String(query || '').trim();
    if (!q) return escapeHtml(raw);

    var escaped = escapeHtml(raw);
    var pattern;
    try {
      pattern = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    } catch (err) {
      return escaped;
    }
    return escaped.replace(pattern, '<mark class="diagnox-search-modal__mark">$1</mark>');
  }

  function plainDescription(product) {
    var body = stripHtml(product && (product.body || product.body_html || ''));
    if (body) return body;
    return stripHtml((product && product.product_type) || '');
  }

  function isBiomarkerProduct(product, meta) {
    var type = String((meta && meta.productType) || product.product_type || '').toLowerCase();
    var tags = meta && meta.tags ? meta.tags : product.tags || [];
    var tagStr = Array.isArray(tags) ? tags.join(' ').toLowerCase() : String(tags).toLowerCase();
    return (
      type.indexOf('biomarker') !== -1 ||
      tagStr.indexOf('biomarker') !== -1 ||
      type.indexOf('marker') !== -1
    );
  }

  function pickImage(resource) {
    if (!resource) return '';
    if (typeof resource.image === 'string') return resource.image;
    if (resource.image && resource.image.url) return resource.image.url;
    if (typeof resource.featured_image === 'string') return resource.featured_image;
    if (resource.featured_image && resource.featured_image.url) return resource.featured_image.url;
    return '';
  }

  function buildMedia(image) {
    return image
      ? '<img src="' + escapeHtml(image) + '" alt="" width="48" height="48" loading="lazy">'
      : '<span class="diagnox-search-modal__result-placeholder" aria-hidden="true"></span>';
  }

  function buildResultRow(item, query, options) {
    options = options || {};
    var url = escapeHtml(item.url || '#');
    var title = highlight(item.title || '', query);
    var descPlain = stripHtml(item.description || '');
    var desc = descPlain
      ? '<span class="diagnox-search-modal__result-desc">' +
        highlight(descPlain, query) +
        '</span>'
      : '';
    var metaHtml = '';

    if (options.showViewButton) {
      metaHtml =
        '<span class="diagnox-search-modal__result-action">' +
        escapeHtml(viewLabelFromSample(item.testSample)) +
        '</span>';
    } else if (options.metaLabel) {
      metaHtml =
        '<span class="diagnox-search-modal__result-meta">' +
        escapeHtml(options.metaLabel) +
        '</span>';
    }

    return (
      '<a href="' +
      url +
      '" class="diagnox-search-modal__result" data-result-type="' +
      escapeHtml(item.type || '') +
      '">' +
      '<span class="diagnox-search-modal__result-media">' +
      buildMedia(item.image) +
      '</span>' +
      '<span class="diagnox-search-modal__result-copy">' +
      '<span class="diagnox-search-modal__result-title">' +
      title +
      '</span>' +
      desc +
      '</span>' +
      metaHtml +
      '</a>'
    );
  }

  function buildSection(title, rowsHtml) {
    if (!rowsHtml) return '';
    return (
      '<section class="diagnox-search-modal__group">' +
      '<h3 class="diagnox-search-modal__section-title">' +
      escapeHtml(title) +
      '</h3>' +
      '<div class="diagnox-search-modal__group-list">' +
      rowsHtml +
      '</div>' +
      '</section>'
    );
  }

  function normalizePredictivePayload(data, metaMap) {
    var resources = (data && data.resources && data.resources.results) || {};
    var products = resources.products || [];
    var articles = resources.articles || [];
    var groups = {
      products: [],
      biomarkers: [],
      conditions: [],
      articles: [],
      faqs: []
    };

    products.forEach(function (product) {
      var meta = lookupProductMeta(metaMap, product) || {};
      var item = {
        type: 'product',
        title: stripHtml(product.title || ''),
        url: product.url,
        description: plainDescription(product),
        image: pickImage(product),
        testSample: meta.testSample || '',
        handle: product.handle || handleFromUrl(product.url)
      };

      if (isBiomarkerProduct(product, meta)) {
        groups.biomarkers.push(item);
      } else {
        groups.products.push(item);
      }
    });

    articles.forEach(function (article) {
      groups.articles.push({
        type: 'article',
        title: stripHtml(article.title || ''),
        url: article.url,
        description: stripHtml(article.body || article.summary || ''),
        image: pickImage(article)
      });
    });

    return groups;
  }

  function init(root) {
    var input = root.querySelector('[data-diagnox-search-input]');
    var emptyStateEl = root.querySelector('[data-diagnox-empty-state]');
    var featuredResultsEl = root.querySelector('[data-diagnox-featured-results]');
    var searchResultsEl = root.querySelector('[data-diagnox-search-results]');
    var typeInput = root.querySelector('[data-search-type-input]');
    var tabs = root.querySelectorAll('[data-search-tab]');
    var chips = root.querySelectorAll('[data-diagnox-search-chip]');
    var closeBtn = root.querySelector('.js-modal-close');
    var panel = root.querySelector('.diagnox-search-modal__panel') || root.querySelector('.modal__inner');
    var productMeta = parseProductMeta(root);
    var contentIndex = parseContentIndex(root);

    if (!input || !featuredResultsEl || !searchResultsEl) return;

    function sanitizeResultDescriptions(container) {
      if (!container) return;
      container.querySelectorAll('.diagnox-search-modal__result-desc').forEach(function (el) {
        el.textContent = stripHtml(el.textContent || el.innerHTML || '');
      });
    }

    sanitizeResultDescriptions(featuredResultsEl);
    var activeTab = 'all';
    var abortController = null;
    var predictiveBase = root.getAttribute('data-predictive-url') || '/search/suggest';

    function setEmptyState(isEmpty) {
      root.classList.toggle('is-searching', !isEmpty);
      if (emptyStateEl) emptyStateEl.hidden = !isEmpty;
      searchResultsEl.hidden = isEmpty;
      if (isEmpty) {
        searchResultsEl.innerHTML = '';
      }
    }

    function setTab(tab) {
      activeTab = tab || 'all';
      tabs.forEach(function (btn) {
        var isActive = btn.getAttribute('data-search-tab') === activeTab;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (typeInput) {
        if (activeTab === 'product') typeInput.value = 'product';
        else if (activeTab === 'article') typeInput.value = 'article';
        else typeInput.value = root.getAttribute('data-search-type') || 'product,article';
      }

      var query = input.value.trim();
      if (query) runSearch(query);
      else showEmptyState();
    }

    function showEmptyState() {
      setEmptyState(true);
      sanitizeResultDescriptions(featuredResultsEl);

      var nodes = featuredResultsEl.querySelectorAll('[data-result-type]');
      var visibleCount = 0;

      nodes.forEach(function (node) {
        var type = node.getAttribute('data-result-type');
        var show = activeTab === 'all' ? !node.hasAttribute('data-tab-only') : type === activeTab;
        node.hidden = !show;
        if (show) visibleCount += 1;
      });

      var emptyMsg = featuredResultsEl.querySelector('[data-diagnox-featured-empty]');
      if (emptyMsg) {
        emptyMsg.hidden = visibleCount > 0;
      }
    }

    function renderSearchResults(groups, query) {
      setEmptyState(false);

      var html = '';
      var hasAny = false;

      function appendGroup(key, title, showView) {
        if (activeTab !== 'all' && TAB_GROUPS[activeTab].indexOf(key) === -1) return;

        var list = groups[key] || [];
        if (!list.length) return;

        hasAny = true;
        var rows = list
          .slice(0, RESULT_LIMIT)
          .map(function (item) {
            return buildResultRow(item, query, {
              showViewButton: !!showView,
              metaLabel: ''
            });
          })
          .join('');
        html += buildSection(title, rows);
      }

      appendGroup('products', 'Products', true);
      appendGroup('biomarkers', 'Biomarkers', false);
      appendGroup('conditions', 'Conditions', false);
      appendGroup('articles', 'Articles', false);
      appendGroup('faqs', 'FAQs', false);

      if (!hasAny) {
        searchResultsEl.innerHTML =
          '<p class="diagnox-search-modal__empty">No matches for “' +
          escapeHtml(query) +
          '”.</p>';
        return;
      }

      searchResultsEl.innerHTML = html;
    }

    function runSearch(query) {
      var q = String(query || '').trim();
      if (!q) {
        showEmptyState();
        return;
      }

      if (abortController) abortController.abort();
      abortController = null;

      function withLocal(groups) {
        groups.biomarkers = searchIndex(contentIndex.biomarker, q, 'biomarker', linkedBiomarkers(productMeta, q)).concat(groups.biomarkers);
        groups.conditions = searchIndex(contentIndex.condition, q, 'condition');
        groups.faqs = searchIndex(contentIndex.faq, q, 'faq');
        return groups;
      }

      var types = PREDICTIVE_TYPES[activeTab];
      if (!types) {
        renderSearchResults(withLocal({ products: [], biomarkers: [], conditions: [], articles: [], faqs: [] }), q);
        return;
      }

      abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url =
        predictiveBase +
        '.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=' +
        encodeURIComponent(types) +
        '&resources[limit]=' +
        RESULT_LIMIT +
        '&resources[options][fields]=title,body,product_type,variants.title,vendor,tag';

      fetch(url, abortController ? { signal: abortController.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error('Predictive search failed');
          return res.json();
        })
        .then(function (data) {
          renderSearchResults(withLocal(normalizePredictivePayload(data, productMeta)), q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          setEmptyState(false);
          searchResultsEl.innerHTML =
            '<p class="diagnox-search-modal__empty">Unable to load suggestions. Press Enter to search.</p>';
        });
    }

    var debouncedSearch = debounce(function () {
      runSearch(input.value);
    }, DEBOUNCE_MS);

    input.addEventListener('input', debouncedSearch);

    var clearBtn = root.querySelector('[data-diagnox-search-clear]');
    function syncClear() {
      if (clearBtn) clearBtn.hidden = !input.value;
    }
    if (clearBtn) {
      input.addEventListener('input', syncClear);
      clearBtn.addEventListener('click', function () {
        input.value = '';
        syncClear();
        input.focus();
        runSearch('');
      });
      syncClear();
    }

    // Enter never leaves the modal: results stay in the search window.
    var form = root.querySelector('[data-diagnox-search-form]');
    if (form) {
      form.addEventListener(
        'submit',
        function (evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          runSearch(input.value);
        },
        true
      );
    }
    input.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter') return;
      evt.preventDefault();
      evt.stopPropagation();
      runSearch(input.value);
    });

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.getAttribute('data-search-tab'));
      });
    });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var q = chip.getAttribute('data-query') || chip.textContent || '';
        input.value = q.trim();
        syncClear();
        input.focus();
        runSearch(input.value);
      });
    });

    function closeModal() {
      if (closeBtn) closeBtn.click();
    }

    var isInline = root.hasAttribute('data-inline');

    root.addEventListener('click', function (evt) {
      if (isInline) return;
      if (!root.classList.contains('modal--is-active')) return;
      if (panel && panel.contains(evt.target)) return;
      if (evt.target.closest('.js-modal-close')) return;
      closeModal();
    });

    if (!isInline) document.addEventListener('modalOpen.SearchModal', function () {
      showEmptyState();
      window.setTimeout(function () {
        input.focus();
        if (input.value && input.select) input.select();
      }, 30);
    });

    if (!isInline) document.addEventListener('modalClose.SearchModal', function () {
      input.value = '';
      syncClear();
      if (abortController) abortController.abort();
      setTab('all');
    });

    showEmptyState();
  }

  function boot() {
    document.querySelectorAll('[data-diagnox-search-modal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
